export default function PhilosophySection() {
  return (
    <section className="w-full flex flex-col md:flex-row" style={{ minHeight: '520px' }}>
      {/* Left half - soft beige with watermark */}
      <div className="md:w-[50%] relative overflow-hidden flex items-end"
        style={{ background: 'oklch(0.96 0.005 85)', minHeight: '420px' }}
      >
        {/* Oversized watermark geometric shape */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[320px] h-[320px] rounded-full opacity-[0.06]"
          style={{
            background: 'radial-gradient(circle, oklch(0.3 0.01 85) 0%, oklch(0.25 0.008 85) 50%, transparent 70%)',
          }}
        />
        <div className="absolute top-[30%] left-[25%] w-[200px] h-[200px] rounded-full opacity-[0.04]"
          style={{
            background: 'radial-gradient(circle, oklch(0.35 0.012 85) 0%, transparent 70%)',
          }}
        />

        {/* Typography in lower-left */}
        <div className="relative z-10 p-8 md:p-12 lg:p-16 pb-14 md:pb-16">
          <p className="font-heading font-bold text-foreground-950 leading-[0.95] tracking-[-0.02em]"
            style={{ fontSize: 'clamp(2.4rem, 5vw, 3.6rem)' }}
          >
            Built for
          </p>
          <p className="font-heading font-bold text-foreground-950 leading-[0.95] tracking-[-0.02em]"
            style={{ fontSize: 'clamp(1.8rem, 3.8vw, 2.6rem)' }}
          >
            the long
          </p>
          <p className="font-heading font-bold text-foreground-950 leading-[0.95] tracking-[-0.02em]"
            style={{ fontSize: 'clamp(1.3rem, 2.8vw, 1.8rem)' }}
          >
            term
          </p>
        </div>
      </div>

      {/* Right half - white */}
      <div className="md:w-[50%] bg-background-50 flex flex-col items-center justify-center text-center px-6 py-14 md:py-0"
        style={{ minHeight: '420px' }}
      >
        <div className="max-w-[420px]">
          <h2 className="font-heading font-bold text-foreground-950 leading-[1.1] tracking-[-0.01em]"
            style={{ fontSize: 'clamp(1.8rem, 3vw, 2.4rem)' }}
          >
            Continuous
            <br />
            Improvement
          </h2>
          <p className="text-sm md:text-[15px] text-foreground-600 mt-8 leading-relaxed">
            Emphasis on continuous innovation, improvement of development workflows,
            and adoption of up-to-date engineering standards to deliver reliable and
            future-ready IT solutions. The team actively explores new technologies
            and evolves internal processes to maintain high technical excellence.
          </p>
          <div className="mt-14 mx-auto w-[40%] h-px bg-foreground-300/50" />
        </div>
      </div>
    </section>
  );
}